import React from 'react';
import { SideNavigation } from '@amzn/awsui-components-react';
import { withRouter } from 'react-router-dom';

function Navigation({ history, activeHref }) {
  const header = { text: 'Menu', href: '/' };
  const items = [
    {
      type: 'link',
      text: 'Welcome',
      href: '/',
    }
  ];

  return (
    <SideNavigation
      items={items}
      header={header}
      activeHref={activeHref}
      onFollow={(e) => {
        e.stopPropagation();
        e.preventDefault();
        history.push(e.detail.href);
      }}
    />
  );
}

export default withRouter(Navigation);